//在列表中删除产品
export let removeData = (originalData, cartId) => {
    let saveData = [];

    originalData.forEach((store) => {
        let saveData_mixList = [];

        store.cartMixList.forEach((list) => {
            let saveData_list = [];

            list.cartList.forEach((proList) => {
                if (proList.product.cartId !== cartId) {
                    saveData_list.push(proList);
                }
            })

            list.cartList = saveData_list;

            if (list.cartList.length > 0) {
                saveData_mixList.push(list);
            }
        })

        store.cartMixList = saveData_mixList;

        if (store.cartMixList.length > 0) {
            saveData.push(store);
        }
    })

    return saveData;
}